var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 52",
    x: 2.30767,
    y: 2.75,
    width: 26,
    height: 25,
    rx: 2,
    fill: "#EFF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 53",
    d: "M1.14232 2.06893C1.23597 1.03877 2.0997 0.25 3.1341 0.25H5.30767V8.8634C5.30767 10.1815 4.23916 11.25 2.92108 11.25C1.51768 11.25 0.417223 10.045 0.544281 8.64733L1.14232 2.06893Z",
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 55",
    d: "M10.3077 0.25H15.3077V8.75C15.3077 10.1307 14.1884 11.25 12.8077 11.25C11.427 11.25 10.3077 10.1307 10.3077 8.75V0.25Z",
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 57",
    d: "M20.3077 0.25H25.3077V8.75C25.3077 10.1307 24.1884 11.25 22.8077 11.25C21.427 11.25 20.3077 10.1307 20.3077 8.75V0.25Z",
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 54",
    d: "M5.30767 0.25H10.3077V8.75C10.3077 10.1307 9.18839 11.25 7.80767 11.25C6.42696 11.25 5.30767 10.1307 5.30767 8.75V0.25Z",
    fill: "#FFA692"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 56",
    d: "M15.3077 0.25H20.3077V8.75C20.3077 10.1307 19.1884 11.25 17.8077 11.25C16.427 11.25 15.3077 10.1307 15.3077 8.75V0.25Z",
    fill: "#FFA692"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 58",
    d: "M25.3077 0.25H27.4812C28.5157 0.25 29.3794 1.03877 29.473 2.06893L30.0711 8.64733C30.1981 10.045 29.0977 11.25 27.6943 11.25C26.3762 11.25 25.3077 10.1815 25.3077 8.8634V0.25Z",
    fill: "#FFA692"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 59",
    d: "M9.30767 16.75C9.30767 15.6454 10.2031 14.75 11.3077 14.75H19.3077C20.4122 14.75 21.3077 15.6454 21.3077 16.75V27.75H9.30767V16.75Z",
    fill: "#8BA293"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.fb9192618d4a56e69942f46c7fb7fb34.svg";
export { ForwardRef as ReactComponent };